<template>

	<v-content>
		<v-container>

			<template v-if="isLoading">
				<div class="text-xs-center pa-5">
					<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
					<div class="caption mt-4">İşlem devam ediyor</div>
				</div>
			</template>

			<div v-if="!isLoading" class="DesignSiteEdit"> 
				<div class="text-xs-center">
					<v-btn outline color="success" @click="saveItem()"><v-icon left dark>save</v-icon> KAYDET</v-btn> 
					<v-btn outline color="pink" @click="display()"><v-icon left dark>remove_red_eye</v-icon> GÖRÜNTÜLE</v-btn> 
				</div>

				<v-text-field label="Genel Başlık" v-model="item.name" placeholder="Örn: Marak Bilgini" outline></v-text-field>

				<v-card class="DesignSiteEditGroup" v-for="(group,groupIndex) in item.groups" :key="groupIndex">
					<v-toolbar color="indigo" dark>
						<v-text-field flat solo-inverted hide-details prepend-inner-icon="bubble_chart"
							v-model="group.name" label="Grup Adı"></v-text-field>
						<v-btn icon @click="moveGroup(groupIndex,1)">
							<v-icon>keyboard_arrow_down</v-icon>
						</v-btn>
						<v-btn icon @click="moveGroup(groupIndex,-1)">
							<v-icon>keyboard_arrow_up</v-icon>
						</v-btn>
						<v-btn icon @click="removeGroup(groupIndex)">
							<v-icon>delete_forever</v-icon>
						</v-btn>
					</v-toolbar>

					<v-list class="groupItems"> 
						<vue-amiral-imagelist v-model="group.items" mediagroup="design_logo" limit="20" sizetype="hvs" /> 
					</v-list>
				</v-card>

				<div class="text-xs-center">
					<v-btn round color="indigo" @click="addNewGroup()" dark>Yeni Grup Ekle</v-btn>
				</div>
 
			</div>

		</v-container>
	</v-content>


</template>



<script>
	export default {
		name: "DesignLogoEdit",
		components: {},
		data() {
			return {
				isLoading: true, 
				isLoading: false, 
				filterText: "",
				id : "",
				item: {},

			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.loadItem();
		},
		methods: { 
			loadItem() {
				if(this.id == ""){ 
					this.item = {
						name: "Yeni",
						groups: [{
								name: "Group 1",
								items: []
							},
							{
								name: "Group 2",
								items: []
							}
						]
					}
				}
				else{
					this.isLoading = true;
					this.$http.get(process.env.VUE_APP_API_URL + "/design/logo/info", {
						params: {
							id : this.id
						}
					}).then(response => {
						this.item = response.body;
						this.isLoading = false;
					})
				}

			},
			saveItem(){
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/design/logo/save", this.item, {
					params: {
							id : this.id
					}
				}).then(response => { 
					this.isLoading = false; 
					if(this.id == ""){ 
						this.$router.push({
							path: '/design/logo',
							query: { 
							}
						})
					}
				})
			},
			addNewGroup() {
				this.item.groups.push({
					name : "#" + (this.item.groups.length + 1),
					items : []
				})
			}, 
			removeGroup(i) {
				this.item.groups.splice(i,1)
			}, 
			moveGroup(i,d) {
				if(d < 0){
					if(i <= 0){return false;}
					var prev  = Object.assign({}, this.item.groups[ i - 1 ]);
					var group = Object.assign({}, this.item.groups[ i ]); 
					this.item.groups[ i - 1 ] = group;
					this.item.groups[ i ] = prev; 
				}
				if(d > 0){
					if(i >= this.item.groups.length){return false;}
					var group = Object.assign({}, this.item.groups[ i ]); 
					var next  = Object.assign({}, this.item.groups[ i + 1 ]);
					this.item.groups[ i ] = next; 
					this.item.groups[ i + 1 ] = group;

				}  
				this.item.groups.push({})
				this.item.groups.splice(this.item.groups.length - 1,1)

			}, 
			display(){ 
				window.open("https://design.ajans360.com/logo/?id="+this.item.id,'_blank');
			}
		},
		computed: {

		}
	}
</script>

<style lang="less">
	.DesignSiteEdit {
		.DesignSiteEditGroup {
			margin-bottom: 15px;
			.groupItems{
				padding : 10px;
			}
		}
	}
</style>